import React from 'react'
import Text from 'react-text'
import confirmDialog from '../../confirm-dialog'
import {deletePlanTemplate} from '../../../context/post'
import {Link} from 'react-router-dom'
import {Consumer} from '../../../context'
import  './templates.styl'

export default function Templates () {
  return (<Consumer>{ context => {

    const {translate, planTemplates} = context
    const deleteDialog = (id, title) => {
      return () =>
        confirmDialog({
          className: 'delete-template',
          translate: translate,
          children: (
            <div className="message">
              <div className="question">
                {translate('confirm_delete_item')}
              </div>
              <div className="title">
                {title}
              </div>
            </div>
          ),
          onConfirm: async () => {
            await deletePlanTemplate(id)
            context.setState({templateUpdates: context.templateUpdates + 1})
          }
        })
    }

    const templates = planTemplates.filter(({label}) => ['default'].indexOf(label) < 0).map(template => {
      return (
        <div className="template" key={template.value} >
          <div className="name">{template.label}</div>
          <div style={{display: "flex", flexGrow: 1}} />
          <div className="delete-template" onClick={deleteDialog(template.value, template.label)}><Text id="delete_label"/></div>
        </div>
      )
    })
    const backPath = context.link({section: undefined}, context.match.path, {preserveQuery: true})

    return (
      <div className="templates">
        <div className="head">
          <Link className = "back" to={backPath} />
          <label><Text id="templates_label" /></label>
        </div>
        <div className="content">
          <div className="title"><Text id="title_label" /></div>
          <div className="templates-wrapper">
            {templates}
          </div>
        </div>
      </div>
    )
    }
  }</Consumer>)
}
